import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=52bc9b81"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports